module.exports = __webpack_public_path__ + "static/img/img4.72c603b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approve/img4.jpg
// module id = TQ8R
// module chunks = 1